export default __webpack_public_path__ + "static/avatar-do-3-dark-93d1b68e3692c25cc2f58b0b04416f8b.png";